import {Col, Container, Modal, Row} from "react-bootstrap";
import {AppContext} from "../../lib/AppContext";
import {useContext, useState} from "react";
import {handleDefaultValues} from "../common/Utils";
import {useForm} from 'react-hook-form';
import MDButton from "../../components/MDButton";
import MDInput from "../../components/MDInput";
import {saveCredentialEmail, sendTestCredentialEmail} from "../common/api/WebApi";

export default function ManageEmailCredential({
                                                credential, show, handleSave, handleClose
                                              }) {

  const [context, setContext] = useContext(AppContext);
  const [formInvalid, setFormInvalid] = useState(false);
  const [isNew, setIsNew] = useState(credential?.id);

  const [saving, setSaving] = useState(false);
  const [testSent, setTestSent] = useState(false);
  const [tested, setTested] = useState(false);

  const [testError, setTestError] = useState(null);

  const {register, handleSubmit, setValue, control} = useForm({
    values: handleDefaultValues(credential)
  });

  const handleFormSave = (formData) => {
    setSaving(true);
    setTestError(null);
    if (!testSent) {
      sendTestCredentialEmail(formData).then((resp) => {
        setTestSent(true);
        setSaving(false);
        setTested(true);
      }).catch((err) => {
        setTestSent(false);
        setSaving(false);
        setTestError(err);
      })
    } else {
      saveCredentialEmail(formData).then((resp) => {
        setTestSent(true);
        setSaving(false);
        setTested(true);
        handleSave('close')
      }).catch((err) => {
        setTestSent(false);
        setSaving(false);
        setTestError(err);
      })
    }

  }

  return (
    <Modal onHide={handleClose} size={'lg'} show={show}>
      <form onSubmit={handleSubmit(handleFormSave)} id={'emailCredentialForm'}>
        <Modal.Header closeButton>
          <Modal.Title>{isNew ? 'Create New' : 'Manage'} Email Credential</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col className={'col col-main'} xs={12}>
              <Container>
                <Row>
                  <Col className={'col'} sm={6} xs={12}>
                    <div className="form-group">
                      <MDInput
                        type="text"
                        {...register('authKey', {
                          autoComplete: 'off'
                        })}
                        InputLabelProps={{shrink: true}}
                        placeholder={"Enter Email"}
                        autoComplete="off" required
                        className="form-control" id="authKey"
                        label="Email"/>

                    </div>
                  </Col>

                  <Col className={'col'} sm={6} xs={12}>
                    <div className="form-group">
                      <MDInput
                        type="password"
                        {...register('password')}
                        InputLabelProps={{shrink: true}}
                        placeholder={"Enter Password"}
                        autoComplete="off" required
                        className="form-control" id="password"
                        label="Password"/>

                    </div>
                  </Col>
                </Row>

                <Row className={'mt-4'}>
                  <Col className={'col'} sm={6} xs={12}>
                    <div className="form-group">
                      <MDInput
                        type="text"
                        {...register('host', {
                          autoComplete: 'off',
                        })}
                        InputLabelProps={{shrink: true}}
                        placeholder={"Enter Host"}
                        autoComplete="off" required
                        className="form-control" id="host"
                        label="Host"/>
                    </div>
                  </Col>

                  <Col className={'col'} sm={6} xs={12}>
                    <div className="form-group">
                      <MDInput
                        type="text"
                        {...register('port', {
                          autoComplete: 'off',
                          valueAsNumber: true
                        })}
                        InputLabelProps={{shrink: true}}
                        placeholder={"Enter Port"}
                        autoComplete="off" required
                        className="form-control" id="port"
                        label="Port"/>

                    </div>
                  </Col>
                </Row>
              </Container>
            </Col>
          </Row>
          {testSent && <Row className={'p-3 mt-2'}>
            <Col>
              <p>Check your email for test email. If successful, click Save to continue.</p>
            </Col>
          </Row>}
          {testError && <Row className={'p-3 mt-2'}>
            <Col>
              <p>An error occurred. Please check your credentials are valid.</p>
            </Col>
          </Row>}
        </Modal.Body>
        <Modal.Footer>
          <MDButton type="submit" color="info" disabled={formInvalid || saving}>
            {!testSent && <>
              {saving ? 'Testing...' : 'Test'}
            </>}
            {testSent && <>
              {saving ? 'Saving...' : 'Save'}
            </>}
          </MDButton>
        </Modal.Footer>
      </form>
    </Modal>
  );
}